import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../lib/utils";

function TooltipProvider(props) {
  return <TooltipPrimitive.Provider {...props} />;
}

function Tooltip(props) {
  return <TooltipPrimitive.Root {...props} />;
}

function TooltipTrigger(props) {
  return <TooltipPrimitive.Trigger {...props} />;
}

const TooltipContent = React.forwardRef(
  ({ className, sideOffset = 4, style, ...props }, ref) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          "tw-z-50 tw-overflow-hidden tw-rounded-md tw-bg-surface-secondary tw-border tw-border-white/[0.08] tw-px-3 tw-py-1.5 tw-text-xs tw-text-white tw-shadow-md tw-animate-in tw-fade-in-0 tw-zoom-in-95",
          className
        )}
        style={{
          // Tailwind's tw-z-50 class alone isn't reliable in this codebase
          // (same silent-class-failure pattern as hover states/flex-gap
          // elsewhere) — the topbar is `position: sticky; z-index: 10`
          // (MemberTopBar.jsx), so an inline fallback comfortably above
          // that is needed or the tooltip can render clipped behind it.
          zIndex: 1000,
          background: "#1e1e1e",
          border: "1px solid rgba(255,255,255,0.08)",
          color: "#fff",
          ...style,
        }}
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
);
TooltipContent.displayName = "TooltipContent";

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
